export default __webpack_public_path__ + "static/media/IQMS.9c14f2b2.png";